import Control from "ol/control/Control";
import { UNUSED_SIGN_TYPES, USED_SIGN_TYPES } from "../SDOTrafficSigns";

export class SDOControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const div = document.createElement("div");
    super({
      element: div,
      target: options.target,
    });
    const this_ = this;

    div.className = "sdo-input";

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.className = "sdo-checkbox";
    checkbox.id = "sdo-input";
    checkbox.checked = false;

    checkbox.addEventListener("change", function () {
      this_.set("sdoToggle", checkbox.checked);
    });

    const label = document.createElement("label");
    label.htmlFor = "sdo-input";
    label.className = "sdo-text";
    label.innerText = "SDO";

    const area = document.createElement("p");
    area.className = "sdo-area";
    area.innerText = "Area too large";

    const signSearch = document.createElement("div");
    signSearch.className = "sdo-sign-search";

    const dataList = document.createElement("datalist");
    dataList.id = "sign-selection";

    const dataListInput = document.createElement("input");
    dataListInput.className = "sdo-datalist";
    dataListInput.autocomplete = "on";
    dataListInput.placeholder = "Select a sign type";
    dataListInput.setAttribute("list", "sign-selection");

    dataListInput.addEventListener("change", function (e) {
      if (UNUSED_SIGN_TYPES.includes(e.target.value)) {
        UNUSED_SIGN_TYPES.splice(UNUSED_SIGN_TYPES.indexOf(e.target.value), 1);
        USED_SIGN_TYPES.push(e.target.value);
        this_.set("add_sign", e.target.value + String(Math.random()));

        renderSignTypes();
      }
      dataListInput.value = "";
      dataListInput.blur();
    });

    const dataListDiv = document.createElement("div");
    dataListDiv.appendChild(dataList);
    dataListDiv.appendChild(dataListInput);

    div.appendChild(checkbox);
    div.appendChild(label);
    div.appendChild(area);
    div.appendChild(dataListDiv);
    div.appendChild(signSearch);

    this.on("propertychange", function (e) {
      switch (e.key) {
        case "tooLarge":
          if (this_.get("tooLarge") === true) {
            area.innerText = "Area too large!";
          } else {
            area.innerText = "";
          }
          break;
        case "loading":
          if (this_.get("loading") === true) {
            area.innerText = "Fetching data...";
          } else {
            area.innerText = "";
          }
          break;
        case "idTokenSet":
          if (this_.get("idTokenSet") === false) {
            area.innerText = "Not yet logged in.";
          }
      }
    });

    USED_SIGN_TYPES.map(function (value) {
      if (UNUSED_SIGN_TYPES.includes(value)) {
        UNUSED_SIGN_TYPES.splice(UNUSED_SIGN_TYPES.indexOf(value), 1);
      }
    });

    renderSignTypes();

    function renderSignTypes() {
      dataList.innerHTML = "";
      UNUSED_SIGN_TYPES.sort();
      UNUSED_SIGN_TYPES.map(function (value) {
        const option = document.createElement("option");
        option.value = value;
        option.innerHTML = value;
        dataList.appendChild(option);
      });

      signSearch.innerHTML = "";
      USED_SIGN_TYPES.sort();
      USED_SIGN_TYPES.map(function (value) {
        const removeButton = document.createElement("a");
        removeButton.className = "sdo-sign-button";

        removeButton.addEventListener("click", function (e) {
          if (USED_SIGN_TYPES.includes(e.target.value)) {
            USED_SIGN_TYPES.splice(USED_SIGN_TYPES.indexOf(e.target.value), 1);
            UNUSED_SIGN_TYPES.push(e.target.value);
            this_.set("remove_sign", e.target.value + String(Math.random()));

            renderSignTypes();
          }
        });

        removeButton.innerHTML = "X";
        removeButton.value = value;

        const signSpan = document.createElement("span");
        signSpan.innerHTML = value + " ";

        const signSpanDiv = document.createElement("div");
        signSpanDiv.className = "sdo-sign-span-div";
        signSpanDiv.value = value;
        signSpanDiv.appendChild(signSpan);
        signSpanDiv.appendChild(removeButton);

        signSearch.appendChild(signSpanDiv);
      });
    }
  }
}
